export const CHAT_AGENT_COMPONENT_TYPE = {
    TEXT: 'TEXT',
    QUICK_ANSWERS: 'QUICK_ANSWERS',
    QUICK_ANSWERS_LIST: 'QuickAnswersList',
    DETAILED_ACTION_MODAL: 'DETAILED_ACTION_MODAL',
    PERFORM_NOW: 'PERFORM_NOW',
    ONBOARDING_START_CREATION_FLOW: 'ONBOARDING_START_CREATION_FLOW',
    LOADER: 'LOADER',
    IMAGE_LIST: 'IMAGE_LIST',
    ACTION_BUTTON: 'ACTION_BUTTON',
};
